import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ExtraCreditsForEnterpriseList = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string
			},
			{
				Header: 'country',
				accessor: 'country',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 200
			},
			{
				Header: 'companyID',
				accessor: 'companyId',
				filterType: FilterType.string
			},
			{
				Header: 'givenShipments',
				accessor: 'givenShipments',
				filterType: FilterType.float
			},
			{
				Header: 'remainingShipments',
				accessor: 'remainingShipments',
				filterType: FilterType.float
			},
			{
				Header: 'expiryDate',
				accessor: 'expiryDate',
				filterType: FilterType.date,
				width: 80,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'shipmentType',
				accessor: 'shipmentType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.SHIPMENT_TYPE
			},
			{
				Header: 'givenAmount',
				accessor: 'givenAmount',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'remainingAmount',
				accessor: 'remainingAmount',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string
			},
			{
				Header: 'promoCode',
				accessor: 'promoCode',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'type',
				accessor: 'type',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'promoCodeTransactionID',
				accessor: 'promoCodeTransactionID',
				filterType: FilterType.string,
				show: false
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.EXTRA_CREDITS_ENTERPRISE}
				columns={columns}
				fetchUrl={ADMIN.GET_EXTRA_CREDIT_FOR_ENTERPRISE}
				exportName="extraCreditsEnterpriseExport"
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
			/>
		</TabTableContainer>
	);
};

export default ExtraCreditsForEnterpriseList;
